let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kh3N2")).then(() => parcelRequire('g1kwn'));